<link rel="ractive" href="./package-header.html" name="c-package-header">

<div class="c-search">
	<div class="container-fluid container-mw"><div class="row"><div class="col-xs-12 col-lg-10 col-lg-push-1">
		<div class="search-input-wrapper">
			<input
				class="search-input"
				type="text"
				placeholder="search all of npm"
				value="{{query}}"
				spellcheck="false">

			<div class="search-by">
				<span>Real-time search by </span>
				<a target="_blank" rel="noopener noreferrer" href="https://www.algolia.com">
					<img src="{{@shared.assetsHost}}/img/algolia_grey.svg" title="Algolia">
				</a>
			</div>
			{{#if hideLanding}}
				<div class="filter-by">
					<span>Filter for: </span>
					<button class="btn-package-label btn-esm {{ #if filterType === 'esm' }}active{{ /if }}"
							on-click="@this.setTypeFilter('esm')">ESM</button>
					<button class="btn-package-label btn-cjs {{ #if filterType === 'cjs' }}active{{ /if }}"
							on-click="@this.setTypeFilter('cjs')">CJS</button>
					<button class="btn-package-label btn-js {{ #if filterType === 'js' }}active{{ /if }}"
							on-click="@this.setTypeFilter('js')">JS</button>
					<button class="btn-package-label btn-styles {{ #if filterStyle === 'styles' }}active{{ /if }}"
							on-click="@this.setStyleFilter('styles')">Styles</button>
				</div>
			{{/if}}
		</div>

		{{#if hideLanding}}
			<div class="search-results">
				{{#each packages}}
					<c-package-header
						showSearchElements="true"
						package="{{this}}"
						version="{{version}}"
						query="{{query}}"
						filterType="{{filterType}}"
						filterStyle="{{filterStyle}}"
						packageNameAsLink="true"
						showDownloads="true">
					</c-package-header>
				{{elseif query && nbHits === 0}}
					<div class="no-results">
						<img
							width="270"
							height="148"
							src="{{@shared.assetsHost}}/img/landing/new/no-results.svg"
						/>
						<p class="no-results_title">No results found</p>
					</div>
				{{/each}}
			</div>

			<nav class="search-pagination" aria-label="Search results pagination">
				<div class="pages-counter">
					Page {{page +1}} of {{nbPages}}
				</div>

				<div class="pagination-btn pagination-btn_prev {{#unless page}}pagination-btn_disabled{{/unless}}"
					on-click="page > 0 && @this.subtract('page')">
					<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/chevron-down.svg" />
				</div>

				{{#each pagination(page, nbPages)}}
					<div class="page-num {{#if page === this}}active{{/if}}" on-click="@this.set('page', this)">
						{{this + 1}}
					</div>
				{{/each}}

				<div class="pagination-btn pagination-btn_next {{#unless page + 1 < nbPages}}pagination-btn_disabled{{/unless}}"
					on-click="page + 1 < nbPages && @this.add('page')" >
					<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/chevron-down.svg" />
				</div>
			</nav>
		{{/if}}
	</div></div></div>
</div>

<script>
	const _ = require('../../assets/js/_');
	const debounce = require('../../assets/js/utils/debounce');
	const search = require('../../assets/js/utils/search');

	component.exports = {
		data () {
			return {
				_,
				page: 0,
				query: '',
				packages: [],
				filterType: '',
				filterStyle: '',
				pagination (page, nbPages) {
					let start = Math.max(page - 2, 0);
					let pages = [];

					if (nbPages - page === 1) {
						start = Math.max(Math.min(start, start - 1, start - 2), 0);
					} else if (nbPages - page === 2) {
						start = Math.max(Math.min(start, start - 1), 0);
					}

					for (let i = 0; i < 5 && start + i < nbPages; i++) {
						pages.push(start + i);
					}

					return pages;
				},
			};
		},
		onrender () {
			if (!this.isServer) {
				let offsetTop = scrollY;

				this.find('.search-input').focus({ preventScroll: true });
				this.find('.search-input').focus();
				// Restore scroll position after focusing the input.
				window.scrollTo(0, offsetTop);
				setTimeout(() => window.scrollTo(0, offsetTop), 0);

				if (this.get('caretPosition')) {
					this.find('.search-input').setSelectionRange(this.get('caretPosition'), this.get('caretPosition'));
				}

				let s = debounce((keypath) => {
					if (this.get('query')) {
						let newQuery = this.get('query');

						if (this.get('filterStyle') === 'styles') {
							newQuery += ' style:-none';
						}

						if (this.get('filterType') === 'js') {
							newQuery += ' type:-none';
						}

						if (this.get('filterType') === 'esm' || this.get('filterType') === 'cjs') {
							newQuery += ' type:' + this.get('filterType');
						}


						search(newQuery, this.get('page'), 10).then((result) => {
							// The query might have changed since we sent the request.
							if (result.query === newQuery) {
								this.set('packages', result.response.hits, { shuffle: 'name' });
								this.set('hideLanding', true);

								this.set({
									fadeIn: true,
									nbPages: result.response.nbPages,
									nbHits: result.response.nbHits,
								});

								// Scroll to the results.
								if (!scrollY || keypath === 'page') {
									this.scrollToSearch();
								}
							}
						});
					}
				}, 40);

				// Make sure query is always a string.
				this.observe('query', (value) => {
					if (typeof value !== 'string') {
						this.set('query', String(value));
					}
				});

				// Update results on input.
				this.observe('page query filterType filterStyle __ready', (newValue, oldValue, keypath) => {
					// Don't send requests before have all the data.
					if (this.get('__ready')) {
						// Reset page on query change.
						if (keypath === 'query' && this.get('page') !== 0) {
							this.set('page', 0);
						} else if (!this.get('query')) {
							this.set('hideLanding', false);
							this.set('packages', []);
						} else {
							s(keypath);
						}
					}
				});
			}
		},
		setTypeFilter (filterBy) {
			if (filterBy === this.get('filterType')) {
				this.set('filterType', '');
			} else {
				this.set('filterType', filterBy);
			}
		},
		setStyleFilter (filterBy) {
			if (filterBy === this.get('filterStyle')) {
				this.set('filterStyle', '');
			} else {
				this.set('filterStyle', filterBy);
			}
		},
		scrollToSearch () {
			let page = document.querySelector('html');
			let searchInputEl = this.find('.search-input');
			let scrollToPos = Math.floor(_.getElementOffset(searchInputEl).top / 100) * 100;

			page.scrollTo({
				behavior: 'smooth',
				top: scrollToPos,
			});
		},
	};
</script>
